/**
 * Extract a human-readable message from a thrown API error. `apiFetch` throws an Error whose
 * `.message` is the server's contract message (from `{ error: { message } }`). This also handles
 * the older raw-object shape defensively so every call site can share one helper.
 */
export function errMessage(e: unknown, fallback = 'Something went wrong'): string {
  if (typeof e === 'string') return e;
  if (e && typeof e === 'object') {
    const obj = e as { message?: unknown; error?: { message?: unknown } };
    if (typeof obj.message === 'string' && obj.message) return obj.message;
    if (obj.error && typeof obj.error.message === 'string' && obj.error.message) {
      return obj.error.message;
    }
  }
  return fallback;
}
